const isDownloadPdfButtonInsideRoiCalculator = require("./isDownloadPdfButtonInsideRoiCalculator");
const waitFor300Milliseconds = require("./waitFor300Milliseconds");

/**
 * The iframe content is rendered in Angular.
 * If the button is queried before Angular initializes the DOM, it will be undefined.
 *
 * @param roiCalculatorDocument {Document}
 * @return {Promise<void>}
 */
module.exports = async function waitUntilRoiCalculatorAngularDomIsRendered(roiCalculatorDocument) {
    for (;;) {
        const isRendered = isDownloadPdfButtonInsideRoiCalculator(roiCalculatorDocument);

        if (isRendered) {
            break;
        }

        await waitFor300Milliseconds();
    }
}
